/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelServizioMensaRendicontazioneDTO } from '../model/models';
import { PagedModelServizioMensaRicaricaDTO } from '../model/models';
import { ServizioMensaAddPatchRicaricaForm } from '../model/models';
import { ServizioMensaCalendarioMensaDTO } from '../model/models';
import { ServizioMensaEventoCalendarioDTO } from '../model/models';
import { ServizioMensaEventoCalendarioForm } from '../model/models';
import { ServizioMensaRicaricaDTO } from '../model/models';
import { ServizioMensaRicaricheTotaliDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AddEventoCalendarioStudenteCittadinoRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaEventoCalendarioForm: ServizioMensaEventoCalendarioForm;
}

export interface AddRicaricaStudenteCittadinoRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaAddPatchRicaricaForm: ServizioMensaAddPatchRicaricaForm;
}

export interface AvviaPagamentoStudenteCittadinoRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface CancellaRicaricaStudenteCittadinoRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface DownloadAvvisoStudenteCittadinoRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface DownloadRicevutaStudenteCittadinoRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface GetCalendarioMensaStudenteCittadinoRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface GetTotaliRicaricheStudenteCittadinoRequestParams {
    idStudente: string;
    anno: number;
    gestioneMenseServizioId: string;
}

export interface ListEventiCalendarioStudenteCittadinoRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface ListRendicontazioniStudenteCittadinoRequestParams {
    idStudente: string;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}

export interface ListRicaricheStudenteCittadinoRequestParams {
    idStudente: string;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}

export interface RemoveEventoCalendarioStudenteCittadinoRequestParams {
    idStudente: string;
    idEvento: string;
    gestioneMenseServizioId: string;
}

export interface VerificaRicaricaEseguitaStudenteCittadinoRequestParams {
    idStudente: string;
    iuv: string;
    gestioneMenseServizioId: string;
}


export interface StudenteCittadinoDettaglioServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Aggiunge uno o più eventi calendario a un proprio studente.
     * Specchio cittadino: crea ASSENZA/PASTA_IN_BIANCO per i giorni-mensa del range. forza_evento NON è onorato (parity GENITORE): un evento data-passata/oltre-cutoff → 400. Gate Pratica-accettata + owner-check studente.
     * @endpoint post /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/evento-calendario
* @param requestParameters
     */
    addEventoCalendarioStudenteCittadino(requestParameters: AddEventoCalendarioStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaEventoCalendarioDTO>>;

    /**
     * Crea una ricarica PagoPA per un proprio studente.
     * Ramo PagoPA (il cittadino non accede al ramo manuale: un comune MANUALE non espone la ricarica cittadino). Studente esente → errore; valore &lt; 0 → errore.
     * @endpoint post /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricarica
* @param requestParameters
     */
    addRicaricaStudenteCittadino(requestParameters: AddRicaricaStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDTO>;

    /**
     * Avvia il pagamento PagoPA di una propria ricarica (URL di redirect).
     * 
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/avvia-pagamento
* @param requestParameters
     */
    avviaPagamentoStudenteCittadino(requestParameters: AvviaPagamentoStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Annulla una propria ricarica PagoPA non pagata.
     * Consentito solo sulle ricariche generate dal cittadino stesso (origine CITTADINO) e solo se non ancora pagate (stato IN_ATTESA_PAGAMENTO). Invoca PagoPA, porta la ricarica a CANCELLATA (soft-delete, la riga è conservata) e scollega l\&#39;eventuale rendicontazione; registra una riga audit tipizzata CITTADINO. Ricariche dell\&#39;operatore/di sistema o precedenti alla feature → non annullabili dal cittadino.
     * @endpoint delete /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}
* @param requestParameters
     */
    cancellaRicaricaStudenteCittadino(requestParameters: CancellaRicaricaStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDTO>;

    /**
     * Scarica l\&#39;avviso di pagamento (PDF) di una propria ricarica.
     * Fix authz §18.2.3: audience CITTADINO + owner-check (non più raggiungibile da qualunque autenticato). Avviso senza numero → errore.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/download-avviso-pagamento
* @param requestParameters
     */
    downloadAvvisoStudenteCittadino(requestParameters: DownloadAvvisoStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Scarica la ricevuta di pagamento (PDF) di una propria ricarica.
     * Fix authz §18.2.3: audience CITTADINO + owner-check. Ricevuta senza IUV → errore.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/download-ricevuta-pagamento
* @param requestParameters
     */
    downloadRicevutaStudenteCittadino(requestParameters: DownloadRicevutaStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Calendario mensa (bound + chiusure) della scuola di un proprio studente.
     * Contratto thin a supporto del date picker eventi calendario: data_inizio/data_fine (estremi inclusivi) + regole di chiusura. ASIMMETRIA load-bearing per il FE: chiusure_settimanali VINCOLA il picker (sono le sole chiusure che addEvento sottrae → un evento sull\&#39;unico giorno-weekday del range fallirebbe), mentre chiusure_puntuali è INFO-ONLY (NON blocca l\&#39;aggiunta evento: un POST evento su quella data è accettato — parity legacy). Le puntuali sono filtrate per applicabilità allo studente (scuola-intera + per-classe matchata) e ordinate. Calendario assente/date null → 404 (stessa chiave di POST evento-calendario). Gate Pratica-accettata + owner-check studente.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/calendario-mensa
* @param requestParameters
     */
    getCalendarioMensaStudenteCittadino(requestParameters: GetCalendarioMensaStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaCalendarioMensaDTO>;

    /**
     * Totale dei pagamenti di un proprio studente per anno solare.
     * 
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricariche/totali
* @param requestParameters
     */
    getTotaliRicaricheStudenteCittadino(requestParameters: GetTotaliRicaricheStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricheTotaliDTO>;

    /**
     * Lista degli eventi calendario personali di un proprio studente.
     * Eventi personali ordinati per data, SOLO non-CANCELLATE (la vista cittadino nasconde le cancellazioni, D-18.24). Niente chiusure scolastiche. Gate Pratica-accettata + owner-check.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/evento-calendario
* @param requestParameters
     */
    listEventiCalendarioStudenteCittadino(requestParameters: ListEventiCalendarioStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaEventoCalendarioDTO>>;

    /**
     * Lista paginata delle rendicontazioni di un proprio studente.
     * Solo le rendicontazioni abilitate (le disabilitate non sono esposte al cittadino, D-18.21). Gate Pratica-accettata + owner-check studente.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/rendicontazioni
* @param requestParameters
     */
    listRendicontazioniStudenteCittadino(requestParameters: ListRendicontazioniStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaRendicontazioneDTO>;

    /**
     * Lista paginata delle ricariche di un proprio studente.
     * 
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricariche
* @param requestParameters
     */
    listRicaricheStudenteCittadino(requestParameters: ListRicaricheStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaRicaricaDTO>;

    /**
     * Rimuove (cancella logicamente) un evento calendario di un proprio studente.
     * Specchio cittadino: stato&#x3D;CANCELLATO + audit. forza_evento non onorato (parity GENITORE): evento data-passata/oltre-cutoff → 400. Gate Pratica-accettata + owner-check.
     * @endpoint delete /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/evento-calendario/{id_evento}
* @param requestParameters
     */
    removeEventoCalendarioStudenteCittadino(requestParameters: RemoveEventoCalendarioStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaEventoCalendarioDTO>;

    /**
     * Verifica una ricarica eseguita (single-IUV, accettazione-con-riserva).
     * D-18.16: se PagoPA non conferma, accetta con riserva (PAGATA + pagamento_da_verificare). La riconciliazione batch/webhook resetta il flag.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricarica-eseguita
* @param requestParameters
     */
    verificaRicaricaEseguitaStudenteCittadino(requestParameters: VerificaRicaricaEseguitaStudenteCittadinoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDTO>;

}
